/* Component Dependencies */
var totalForStayTemplate = require('templates/totalForStay.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'totalForStay',
  template: {
    'totalForStay': totalForStayTemplate
  },
  events:{
    'click .stay-summary-expand': 'togglSummaryContent'
  },
  subscribe:{
    'EDIT_PREF_CLOSE': 'refresh',
	'START_ANIMATION_AND_AJAX_CALL': 'triggerAnimationAndAjax'
  },
  bindEvents: function($) {
    var _self = this;
    _self.$el.find('.js-summary-expand').keypress(function (event) {
      if (event.keyCode == '13') {
        $(event.target).trigger('click');
      }
    });

  },
  
  triggerAnimationAndAjax: function _triggerAnimationAndAjax(data) {
    var _self = this;
    if(data == true){
       $('.js-total-stay-price').addClass('lds-line');
       $('.l-sub-total-value').addClass('lds-line');
       $('.l-taxes-value').addClass('lds-line');
       $('.l-total-stay-value').addClass('lds-line');
       $('.js-total-stay-price-span').addClass('l-display-none');
       $('.js-sub-total-value-span').addClass('l-display-none');
       $('.js-total-stay-price-span-value').addClass('l-display-none');
       $('.js-taxes-fee-span').addClass('l-display-none'); 
    }
    else{
      var _self = this;

     var data = {};
     data.context = _self.getContextData();
     data.sessionToken = _self.getSessionToken();
     data.sourceURI = _self.getSourceURI();
     data.variation = _self.getVariation();
     data.context.success = true;

     _self.makeAjaxCall({
          url: "/aries-reservation/v1/totalForStay.comp",
          method: "POST",
          data: JSON.stringify(data),
          success : function(data){
            console.log("Data received :: " + data.component.data.label);
            var response = data.component.data;
			_self.setTotalStayPrice(response);
			_self.setSubTotalStayPrice(response);
			_self.setFinalTotalStayPrice(response);
			$('.js-taxes-fee-span').html(response.taxesAndFee + '<span class="t-font-weight-normal t-font-xxs"> ' + response.currency + '</span>');
			$('.l-taxes-value').removeClass('lds-line');
			$('.js-taxes-fee-span').removeClass('l-display-none');
          },
  
    error: function(jqXHR, textStatus, errorThrown) {
          _self.pubsub.publish('SUMMARY_OF_CHARGE_AJAX_CALL_COMPLETED', [false]);
        }
      });
    }
  },
  
  /**
   * This function is used to update the total Stay Price in Summary Charges Content
   *
   **/

  setTotalStayPrice: function _setTotalStayPrice(response) {
    var _self = this;
      var spanText='';
		if(response.showTotalCash){
			spanText = spanText + response.totalStayPrice + '<span class="t-font-weight-normal t-font-xxs"> ' + response.currency + '</span>';
			if(response.isRedemptiom){
				spanText = spanText + ' <span class="t-icon-plus l-margin-left-quarter l-margin-right-quarter l-currency"></span> ' + (response.reedemedPoints ? response.reedemedPoints : "0") + '<span class="t-font-weight-normal l-margin-left-quarter l-currency"> ' + response.pointsLabel + '</span>';
			}
			$('.js-total-stay-price-span').html(spanText);
		}
		else {
			$('.js-total-stay-price-span').html(response.reedemedPoints + '<span class="t-font-weight-normal t-font-xs"> ' + response.pointsLabel + '</span>');
		}
		$('.js-total-stay-price').removeClass('lds-line');
		$('.js-total-stay-price-span').removeClass('l-display-none');
  },
  
  /**
   * This function is used to update the sub-total Stay Price in Summary Charges Content
   *
   **/

  setSubTotalStayPrice: function _setSubTotalStayPrice(response) {
    var _self = this;
      var spanText='';
		if(response.showSubtotalCash){
			spanText = spanText + response.subtotalPrice + '<span class="t-font-weight-normal t-font-xxs"> ' + response.currency + '</span>';
			if(response.isRedemptiom){
				spanText = spanText + ' <span class="t-icon-plus l-margin-left-quarter l-margin-right-quarter l-currency"></span> ' + (response.reedemedPoints ? response.reedemedPoints : '0') + '<span class="t-font-weight-normal t-font-xs"> ' + response.pointsLabel + '</span>';
			}
			$('.js-sub-total-value-span').html(spanText);
		}
		else {
			$('.js-sub-total-value-span').html((response.reedemedPoints ? response.reedemedPoints : '0') + '<span class="t-font-weight-normal t-font-xs"> ' + response.pointsLabel + '</span>');
		}
		$('.l-sub-total-value').removeClass('lds-line');
		$('.js-sub-total-value-span').removeClass('l-display-none');
  },
  
  /**
   * This function is used to update the Final-total Stay Price in Summary Charges Content
   *
   **/

  setFinalTotalStayPrice: function _setFinalTotalStayPrice(response) {
    var _self = this;
      var spanText='';
		if(response.showTotalCash){
			spanText = spanText + response.totalStayPrice + '<span class="t-font-weight-normal t-font-xxs"> ' + response.currency + '</span>';
			if(response.isRedemptiom){
				spanText = spanText + ' <span class="t-icon-plus l-margin-left-quarter l-margin-right-quarter l-currency"></span> ' + (response.reedemedPoints ? response.reedemedPoints : '0') + '<span class="t-font-weight-normal t-font-xs"> ' + response.pointsLabel + '</span>';
			}
			$('.js-total-stay-price-span-value').html(spanText);
		}
		else {
			$('.js-total-stay-price-span-value').html((response.reedemedPoints ? response.reedemedPoints : '0') + '<span class="t-font-weight-normal l-margin-left-quarter l-currency"> ' + response.pointsLabel + '</span>');
		}
		$('.l-total-stay-value').removeClass('lds-line');
		$('.js-total-stay-price-span-value').removeClass('l-display-none');
  },

  /**
   * This function is used to show/Hide the Summary Charges Content
   *
   **/

  togglSummaryContent: function _togglSummaryContent() {
    var $elm = this.$el;
      $elm.find('.open, .close').toggleClass( 'open close').end()
          .find('.t-icon-arrow-up, .t-icon-arrow-down').toggleClass("t-icon-arrow-up t-icon-arrow-down").end();
  }
});
